//############################################################################
// Pricing tiers ("What you might pay", templates/_modules/pricing-tiers.twig)
//############################################################################

// Shows the calculator's amount and term at each tier's APR. The calculator
// (calcInline.js) announces every recalculation with a "calc:updated" event.
import { monthlyRepayment } from '../shared/calc-data'

const numeral = require("numeral");

const tiers = document.querySelector('#pricing-tiers');

if (tiers) {
    const amount = tiers.querySelector('[data-tier-amount]');
    const term = tiers.querySelector('[data-tier-term]');
    const rows = tiers.querySelectorAll('[data-tier-apr]');
    const link = tiers.querySelector('[data-tier-link]');
    const queryStr = window.location.search.replace('?', '');

    document.addEventListener('calc:updated', (e) => {
        const { loanValue, loanTerm } = e.detail;

        // Same apply link as the calculator's button
        if (link) {
            link.href = link.dataset.enquiryUrl + "?LoanAmount=" + loanValue + "&LoanTermInMonths=" + loanTerm + (queryStr ? "&" + queryStr : "");
        }

        amount.textContent = numeral(loanValue).format("0,0");
        term.textContent = loanTerm % 12 === 0
            ? (loanTerm / 12) + (loanTerm === 12 ? ' year' : ' years')
            : loanTerm + ' months';

        for (let i = 0; i < rows.length; i++) {
            const apr = rows[i].dataset.tierApr / 100;
            const monthly = +monthlyRepayment(apr, loanValue, loanTerm).toFixed(2);
            rows[i].querySelector('[data-tier-monthly]').textContent = numeral(monthly).format("0,0.00");
        }
    });
}
